var map = {
	"./404-bg.svg": "5238",
	"./SPlogo.svg": "0fdb",
	"./action-blue.svg": "e9d5",
	"./action-dark.svg": "d201",
	"./action-dark2.svg": "745a",
	"./action-gray.svg": "eb3d",
	"./action-white.svg": "e169",
	"./activity.svg": "16de",
	"./add.svg": "168c",
	"./bilo.png": "dd84",
	"./bitmap@2x.jpg": "736c",
	"./calendar.svg": "b688",
	"./check.svg": "7378",
	"./chevron-down-blue.svg": "3355",
	"./chevron-down-dark.svg": "56b5",
	"./chevron-down-gray-dark копія.svg": "27c6",
	"./chevron-down-gray-dark.svg": "7d9c",
	"./chevron-down-gray.svg": "5456",
	"./chevron-down-white.svg": "6198",
	"./chevron-down.svg": "c279",
	"./chevron-left-blue.svg": "90d5",
	"./chevron-left-small-gray.svg": "0429",
	"./chevron-left-small.svg": "af01",
	"./chevron-left.svg": "452e",
	"./chevron-right.svg": "5bf8",
	"./chick-fil-a-logo.png": "b0f8",
	"./close-dark-old.svg": "90f6",
	"./close-dark.svg": "bd9c",
	"./close-gray.svg": "fa4d",
	"./close-white.svg": "9cb9",
	"./close.svg": "66ca",
	"./co-pace-blueprint.png": "19d2",
	"./co-pace-how.png": "e858",
	"./co-pace-logo.png": "2fdd",
	"./colgate-logo.png": "239f",
	"./core-enterprises.svg": "ab9b",
	"./core-user.svg": "5e79",
	"./dashboard-placeholder.png": "b606",
	"./dashboard.png": "9fce",
	"./default_startup_logo.svg": "81c2",
	"./drag-n-drop2-blue.svg": "7470",
	"./drag-n-drop2.svg": "c53d",
	"./dropdown-arrow-top.png": "d265",
	"./edit-white.svg": "5cfb",
	"./edit.svg": "4038",
	"./engagements.png": "d28d",
	"./global.png": "c92f",
	"./greeting.png": "f468",
	"./group-7.svg": "3638",
	"./group.svg": "e139",
	"./home.svg": "376f",
	"./icon-action-light.svg": "4c25",
	"./icon-action-more.svg": "833f",
	"./icon-action-report.svg": "fa00",
	"./icon-actions-edit.svg": "b3ff",
	"./icon-activity-blue.svg": "d1eb",
	"./icon-activity-call-active.svg": "f526",
	"./icon-activity-call.svg": "8024",
	"./icon-activity-demo-active.svg": "9ba8",
	"./icon-activity-demo.svg": "79cf",
	"./icon-activity-email-active.svg": "5562",
	"./icon-activity-email.svg": "b116",
	"./icon-activity-meeting-active.svg": "ed93",
	"./icon-activity-meeting.svg": "8dcc",
	"./icon-activity-news-active.svg": "da8c",
	"./icon-activity-news.svg": "7e94",
	"./icon-activity-note-active.svg": "38c0",
	"./icon-activity-note.svg": "95d3",
	"./icon-add-dark.svg": "7866",
	"./icon-add-light-blue.svg": "0736",
	"./icon-add-light-gray.svg": "4377",
	"./icon-add-light-white.svg": "57fa",
	"./icon-add-light.svg": "8802",
	"./icon-add-need.svg": "f598",
	"./icon-add-red.svg": "f1fc",
	"./icon-add-white.svg": "8b10",
	"./icon-add.svg": "300a",
	"./icon-admin-blue.svg": "3533",
	"./icon-admin-light.svg": "75b3",
	"./icon-admin.svg": "08b3",
	"./icon-ai-blue.svg": "9ea7",
	"./icon-ai-dark-blue.svg": "fce8",
	"./icon-ai-dark-blue2.svg": "a75b",
	"./icon-ai-failed.svg": "082c",
	"./icon-ai-generated-plate.png": "0b45",
	"./icon-ai-generated.svg": "5cc1",
	"./icon-ai-gray.svg": "86be",
	"./icon-ai-light-blue.svg": "6f53",
	"./icon-ai-light-purple-gradient.svg": "f60a",
	"./icon-ai-light-purple.svg": "52b1",
	"./icon-ai-purple.svg": "2cda",
	"./icon-ai-similar-blue.svg": "99ed",
	"./icon-ai-similar.svg": "fef8",
	"./icon-ai.svg": "5c59",
	"./icon-approved.svg": "31c1",
	"./icon-archive-light.svg": "9dc7",
	"./icon-arrow-black.svg": "e1f1",
	"./icon-arrow-triangle-shadow2-yellow.svg": "1ede",
	"./icon-arrow-triangle-shadow2.svg": "c086",
	"./icon-arrow-white.svg": "37e2",
	"./icon-arrow.svg": "f789",
	"./icon-article.svg": "6d47",
	"./icon-attach.png": "b0be",
	"./icon-badge.png": "e5fd",
	"./icon-bin-light.svg": "3a05",
	"./icon-binoculars-active.svg": "9394",
	"./icon-binoculars-light-gray.svg": "e811",
	"./icon-binoculars-light.svg": "5bce",
	"./icon-binoculars.svg": "365f",
	"./icon-blank.svg": "e803",
	"./icon-boolean-blue.svg": "fcba",
	"./icon-boolean.svg": "61e0",
	"./icon-bottom-arrow.svg": "1d3c",
	"./icon-building-blue.svg": "f870",
	"./icon-building-dark.svg": "312d",
	"./icon-building-green.svg": "c547",
	"./icon-building.svg": "c4ed",
	"./icon-calendar.svg": "6295",
	"./icon-call-light-white.svg": "75d4",
	"./icon-call-light.svg": "180e",
	"./icon-call.svg": "d489",
	"./icon-categories.svg": "a441",
	"./icon-category-light.svg": "1757",
	"./icon-category.svg": "148b",
	"./icon-chat-active.svg": "6009",
	"./icon-chat-blue-light.svg": "3def",
	"./icon-chat-blue.svg": "cd71",
	"./icon-chat-light.svg": "31b3",
	"./icon-chat.svg": "215a",
	"./icon-check-gray.svg": "cb35",
	"./icon-check.svg": "2410f",
	"./icon-checkmark-blue.svg": "4f47",
	"./icon-checkmark-gray.svg": "7a31",
	"./icon-checkmark-gray2.svg": "47c1",
	"./icon-checkmark-purple.svg": "19b4",
	"./icon-checkmark.svg": "d483",
	"./icon-checkmarklight-blue.svg": "639f",
	"./icon-clear-blue.svg": "50614",
	"./icon-clear.svg": "6f2c",
	"./icon-clients-blue.svg": "5939",
	"./icon-clients-gray-dark.svg": "bc9d",
	"./icon-clients-gray.svg": "bdf4",
	"./icon-clients-white.svg": "1122",
	"./icon-clients.svg": "480d",
	"./icon-clock-gray-light.svg": "308d",
	"./icon-clock-light.svg": "9d66",
	"./icon-clock-white.svg": "05ee",
	"./icon-clock.svg": "4dfe",
	"./icon-close-blue.svg": "05ed",
	"./icon-close-dark.svg": "1c65",
	"./icon-close-light.svg": "4f48",
	"./icon-close-red-light.svg": "895b",
	"./icon-close-red.svg": "7836",
	"./icon-close-white.svg": "bb97",
	"./icon-compose-gray.svg": "8300",
	"./icon-compose.svg": "671a",
	"./icon-copy-dark.svg": "9a79",
	"./icon-copy-light.svg": "0e65",
	"./icon-copy-white.svg": "e59a",
	"./icon-copy.svg": "a54b",
	"./icon-corporate.png": "ff5d",
	"./icon-corporate2.svg": "f0cc",
	"./icon-critical.svg": "04a1",
	"./icon-csv.svg": "3b84",
	"./icon-custom-remove-dark.svg": "52b5",
	"./icon-custom-remove.svg": "a66c",
	"./icon-data-gray.svg": "fd10",
	"./icon-data-light.svg": "59b0",
	"./icon-data.svg": "5dec",
	"./icon-delete-light-blue.svg": "47b7",
	"./icon-delete-light.svg": "eba2",
	"./icon-demo-light-white.svg": "1c99",
	"./icon-demo-light.svg": "5ae7",
	"./icon-demo.svg": "0afb",
	"./icon-diagonal-up-arrow.svg": "3a69",
	"./icon-double-arrow.svg": "195a",
	"./icon-download-blue-dark.svg": "13ea",
	"./icon-download-blue.svg": "8bfe",
	"./icon-download.png": "768e",
	"./icon-drag-n-drop-blue.svg": "3039",
	"./icon-drag-n-drop.svg": "28d8",
	"./icon-dropdown-light-white.svg": "91c3",
	"./icon-dropdown-light.svg": "f1b6",
	"./icon-dropdown-white.svg": "d9f7",
	"./icon-ecosystem-black.svg": "e39f",
	"./icon-ecosystem-blue.svg": "cad9",
	"./icon-ecosystem-gray-dark.svg": "0303",
	"./icon-ecosystem-gray.svg": "63c0",
	"./icon-ecosystem-graylight.svg": "149e",
	"./icon-ecosystem-green.svg": "25e1",
	"./icon-ecosystem-light-black.svg": "5e53",
	"./icon-ecosystem-light-blue.svg": "bfd6",
	"./icon-ecosystem-light.svg": "a00c",
	"./icon-ecosystem-white.svg": "514c",
	"./icon-edit-blue.svg": "952d",
	"./icon-edit-light-gray.svg": "2e0f",
	"./icon-edit-light-red.svg": "13f3",
	"./icon-edit-light.svg": "6ef4",
	"./icon-edit-prompt.svg": "5eba",
	"./icon-edit.svg": "3f09",
	"./icon-email-light-white.svg": "f119",
	"./icon-email-light.svg": "07b4",
	"./icon-email.svg": "5e31",
	"./icon-employees-light-gray.svg": "11ad",
	"./icon-employees-light.svg": "254b",
	"./icon-enter.png": "0105",
	"./icon-enterprise-blue-small.svg": "ecad",
	"./icon-enterprise-blue.svg": "01bd",
	"./icon-enterprise-gray.svg": "37ba",
	"./icon-enterprise-white.svg": "eb9c",
	"./icon-enterprise.svg": "00ad",
	"./icon-envelope-light.svg": "d757",
	"./icon-escalated-white.svg": "e9a5",
	"./icon-escalated.svg": "a935",
	"./icon-export-blue.svg": "4042",
	"./icon-export-csv.svg": "1de6",
	"./icon-export-light-blue.svg": "ee0a",
	"./icon-export-pdf-blue.svg": "5116",
	"./icon-export-pdf.svg": "8fb5",
	"./icon-export-ppt.svg": "f0f9",
	"./icon-export-white.svg": "15ed",
	"./icon-export.svg": "5ea7",
	"./icon-eye-gray.svg": "7794",
	"./icon-eye-hide-gray.svg": "9044",
	"./icon-eye-hide.svg": "0168",
	"./icon-eye-show.svg": "0faf",
	"./icon-eye.svg": "72ed",
	"./icon-facebook.svg": "bbaa",
	"./icon-favorite-light.svg": "85f8",
	"./icon-file-csv.svg": "893b",
	"./icon-file.svg": "8da8",
	"./icon-filter-light-blue.svg": "1336",
	"./icon-folder-light-black.svg": "b839",
	"./icon-folder-light-blue.svg": "4cfb",
	"./icon-folder-light.svg": "b021",
	"./icon-folder-white.svg": "c1fa",
	"./icon-folder.svg": "8eae",
	"./icon-founded-light.png": "519c",
	"./icon-founded-light.svg": "4eb5",
	"./icon-founded.svg": "6012",
	"./icon-funding-blue.svg": "5d3d",
	"./icon-funding-green.svg": "09ff",
	"./icon-funding-light.png": "6c82",
	"./icon-funding-light.svg": "c8e0",
	"./icon-funding.svg": "a343",
	"./icon-gen-ai-gradient.svg": "0bbe",
	"./icon-gen-ai-off.svg": "19c6",
	"./icon-gen-ai.svg": "c9b6",
	"./icon-general-edit.svg": "d690",
	"./icon-globe-black.svg": "0559",
	"./icon-globe-light.svg": "1776",
	"./icon-globe.svg": "6c87",
	"./icon-grid-blue.svg": "0b0a",
	"./icon-grid.svg": "b7a0",
	"./icon-heart.svg": "982c",
	"./icon-help-button.svg": "6afb",
	"./icon-history.svg": "6eac",
	"./icon-home-light.svg": "d5f0",
	"./icon-home-white.svg": "9f2a",
	"./icon-home.svg": "47ea",
	"./icon-income-blue.svg": "06d1",
	"./icon-income-light-blue.svg": "1cf2",
	"./icon-income-light.png": "179b",
	"./icon-income.svg": "7806",
	"./icon-info-gray.svg": "0ae8",
	"./icon-info-light-blue.svg": "c2f6",
	"./icon-info-light.svg": "9c70",
	"./icon-info-white-gray.svg": "f31b",
	"./icon-info-white.svg": "5110",
	"./icon-info.svg": "7eb6",
	"./icon-information.svg": "6690",
	"./icon-intelligence.svg": "fa97",
	"./icon-invite.svg": "c960",
	"./icon-knowledge.svg": "94c4",
	"./icon-knowledge.webp": "dbc3",
	"./icon-leave.svg": "f195",
	"./icon-light-clock.svg": "9f83",
	"./icon-light-ecosystem-white.svg": "8de5",
	"./icon-light-startup-white.svg": "aa7a",
	"./icon-light-tag-blue.svg": "8598",
	"./icon-light-tag.svg": "b130",
	"./icon-light-tasks-white.svg": "6dbe",
	"./icon-light-text-blue.svg": "ffd1",
	"./icon-light-text.svg": "cfcf",
	"./icon-light-track-white.svg": "1315",
	"./icon-light-tracker.svg": "45af",
	"./icon-light-user-white.svg": "3619",
	"./icon-light-user.svg": "357a",
	"./icon-lightbulb-gray.svg": "e550",
	"./icon-lightbulb-light-blue.svg": "c17e",
	"./icon-lightbulb-light.svg": "d99e",
	"./icon-lightbulb.svg": "bd72",
	"./icon-link.svg": "1495",
	"./icon-list-mouse.svg": "85a8",
	"./icon-list-view-light.svg": "a56e",
	"./icon-list-view-opacity.svg": "d218",
	"./icon-list-view.svg": "8f60",
	"./icon-list.svg": "e446",
	"./icon-ln.svg": "2d8f",
	"./icon-location-blue.svg": "40384",
	"./icon-location-light.png": "9b2d",
	"./icon-location-light.svg": "fbbb",
	"./icon-location.svg": "32c8",
	"./icon-lock-white.svg": "ebe6",
	"./icon-logout.svg": "d96b",
	"./icon-logs-light.svg": "ef5d",
	"./icon-magicglass-gradient.svg": "b574",
	"./icon-market-report.png": "b2e5",
	"./icon-medium-blue.svg": "8c56",
	"./icon-medium.svg": "5f75",
	"./icon-meeting.svg": "d1e0",
	"./icon-merge.svg": "a833",
	"./icon-message.svg": "4a5a",
	"./icon-minimize.svg": "3a3d",
	"./icon-minus-blue.svg": "4910",
	"./icon-minus.svg": "d547",
	"./icon-modify.svg": "e724",
	"./icon-mouse.svg": "1b6b",
	"./icon-needs-ai.svg": "8ad2",
	"./icon-needs-arrow.svg": "4ed1",
	"./icon-needs-ecosystem.svg": "d625",
	"./icon-needs-search.svg": "f36e",
	"./icon-news-gray.svg": "9d36",
	"./icon-news.png": "e44d",
	"./icon-no-content.svg": "6ec3",
	"./icon-no-tasks.svg": "fa17",
	"./icon-no-template.svg": "66ef",
	"./icon-note-from.svg": "76bb",
	"./icon-note-gray.svg": "c8de",
	"./icon-note-light-blue.svg": "c335",
	"./icon-note-light-gray.svg": "b7c7",
	"./icon-note-light-white.svg": "88b0",
	"./icon-note-light.svg": "b838",
	"./icon-note.svg": "6320",
	"./icon-notification-light-blue-off.svg": "d6aa",
	"./icon-notification-light-blue.svg": "7a48",
	"./icon-notification-off.svg": "bda8",
	"./icon-notification.svg": "2fcf",
	"./icon-notifications.svg": "d2dd",
	"./icon-noupdates.svg": "9251",
	"./icon-offset.svg": "a67b",
	"./icon-open-popup-normal.svg": "2f11",
	"./icon-open-popup-round.svg": "d1bb",
	"./icon-open-popup-transparent.svg": "b6d3",
	"./icon-open-popup-white.svg": "e7ee",
	"./icon-open-popup.svg": "a053",
	"./icon-partnership.png": "f3bd",
	"./icon-partnership2.svg": "3ae8",
	"./icon-pdf.svg": "bb14",
	"./icon-pending.svg": "5da8",
	"./icon-pic.svg": "c316",
	"./icon-pin.svg": "a903",
	"./icon-play-video.svg": "1097",
	"./icon-play.svg": "4031",
	"./icon-portfolio.svg": "384b",
	"./icon-ppt.svg": "061c",
	"./icon-premium.svg": "1746",
	"./icon-priority-critical.png": "edf6",
	"./icon-priority-high.png": "eef0",
	"./icon-priority-low.png": "1102",
	"./icon-priority-medium.png": "6a3b",
	"./icon-privacy.svg": "d1db",
	"./icon-profile-gray.svg": "f4d2",
	"./icon-profile.svg": "f39f",
	"./icon-pushpin-blue.svg": "2ede",
	"./icon-pushpin.svg": "8e59",
	"./icon-question-blue.svg": "dbf4",
	"./icon-question-light-blue.svg": "d1a0",
	"./icon-question-mark-blue.svg": "1030",
	"./icon-quote.svg": "65b3",
	"./icon-r-play-dark.svg": "5379",
	"./icon-r-play.svg": "9d5b",
	"./icon-radar-light.svg": "f82b",
	"./icon-radar.svg": "7e99",
	"./icon-rated.svg": "6ece",
	"./icon-ratings-light.svg": "be0e",
	"./icon-relations.svg": "801a",
	"./icon-reload.svg": "2019",
	"./icon-remove-light.svg": "da73",
	"./icon-remove-red-bg.svg": "c1097",
	"./icon-remove-red.svg": "fe74",
	"./icon-remove.svg": "4196",
	"./icon-report-creating.svg": "b774",
	"./icon-report-light.svg": "5bc7",
	"./icon-report-triangle.svg": "50f6",
	"./icon-report.svg": "a4aa",
	"./icon-reporting-light.svg": "c796",
	"./icon-reporting.svg": "cab5",
	"./icon-resize.svg": "540a",
	"./icon-save-light-blue.svg": "2cd3",
	"./icon-save-light.svg": "c659",
	"./icon-save-light2.svg": "4a9f",
	"./icon-save.svg": "42a8",
	"./icon-schedule-gray.svg": "fa4a",
	"./icon-schedule.svg": "ad20",
	"./icon-score0.svg": "24fc",
	"./icon-score1.svg": "5219",
	"./icon-score10.svg": "2816",
	"./icon-score2.svg": "02c3",
	"./icon-score3.svg": "f648",
	"./icon-score4.svg": "5b76",
	"./icon-score5.svg": "c6b4",
	"./icon-score6.svg": "543e",
	"./icon-score7.svg": "15db",
	"./icon-score8.svg": "b914",
	"./icon-score9.svg": "423f",
	"./icon-search-black.svg": "b33d",
	"./icon-search-blue.svg": "12bc",
	"./icon-search-button-purple.svg": "933e",
	"./icon-search-button.png": "3919",
	"./icon-search-button.svg": "0544",
	"./icon-search-gray.svg": "c1a9",
	"./icon-search-light-blue.svg": "9215",
	"./icon-search-lightgray.svg": "49df",
	"./icon-search-white-slim.svg": "c9e2",
	"./icon-search-white.svg": "2621",
	"./icon-select-arrow-white.svg": "463e",
	"./icon-select-arrow.svg": "276b",
	"./icon-select-blue.svg": "65e7",
	"./icon-select-down-white.svg": "5f76",
	"./icon-select-gray.svg": "48c7",
	"./icon-select-white.svg": "f08c",
	"./icon-select.svg": "45b6",
	"./icon-send.svg": "4895",
	"./icon-settings-light-blue.svg": "5d29",
	"./icon-settings-light.svg": "e0a3",
	"./icon-settings.svg": "145c",
	"./icon-share-light.svg": "95a4",
	"./icon-share-portfolio.png": "4b94",
	"./icon-share-portfolio.svg": "cf3a",
	"./icon-share.svg": "40e9",
	"./icon-show.svg": "c2e3",
	"./icon-similar-blue.svg": "cec6",
	"./icon-similar-gray.svg": "0b8f",
	"./icon-similar-light-blue.svg": "8113",
	"./icon-sort-light.svg": "b4a6",
	"./icon-speed-0.svg": "b24c",
	"./icon-speed-1.svg": "0109",
	"./icon-speed-10.svg": "61d8",
	"./icon-speed-2.svg": "31b5",
	"./icon-speed-3.svg": "0409",
	"./icon-speed-4.svg": "eec4",
	"./icon-speed-5.svg": "ab60",
	"./icon-speed-6.svg": "4c68",
	"./icon-speed-7.svg": "c49c",
	"./icon-speed-8.svg": "5f06",
	"./icon-speed-9.svg": "60ae",
	"./icon-speed-base.svg": "1df6",
	"./icon-speed-light-simple.svg": "325d",
	"./icon-speed-light.svg": "0ca2",
	"./icon-speed.svg": "b41d",
	"./icon-star-light.svg": "17da",
	"./icon-start-ups-blue.svg": "3c4e",
	"./icon-startup-gray.svg": "e6c4",
	"./icon-startup-light-blue.svg": "9cb3",
	"./icon-startup-light-gray-dark.svg": "f817",
	"./icon-startup-light-gray.svg": "e445",
	"./icon-startup-light-white.svg": "423f6",
	"./icon-startup-light.svg": "71f1",
	"./icon-startup-white.svg": "aafd",
	"./icon-startup.png": "0f01",
	"./icon-startups-gray.svg": "052c",
	"./icon-startups-light.png": "62f6",
	"./icon-startups-white.svg": "1311",
	"./icon-sync.svg": "f7bf",
	"./icon-tag-light-blue.svg": "504b",
	"./icon-tag-light.svg": "98ff",
	"./icon-tag.svg": "fc7f",
	"./icon-task-blue.svg": "dfbe",
	"./icon-task.svg": "4d93",
	"./icon-tasks-blue.svg": "8fe1",
	"./icon-tasks.svg": "726a",
	"./icon-team-light-blue.svg": "0764",
	"./icon-team-light.svg": "f2c7",
	"./icon-team-white.svg": "7bc4",
	"./icon-team.svg": "9693",
	"./icon-template-light-blue.svg": "2156",
	"./icon-text-document.webp": "d18a",
	"./icon-thumbs-down-fill.svg": "5424",
	"./icon-thumbs-down-full.svg": "09e2",
	"./icon-thumbs-up-blue.svg": "ff4b",
	"./icon-thumbs-up-fill.svg": "bdc9",
	"./icon-thumbs-up-full.svg": "eb06",
	"./icon-thumbs-up.svg": "fd91",
	"./icon-tool.svg": "4ea3",
	"./icon-top-arrow-opacity.svg": "bad1",
	"./icon-top-arrow.svg": "3ad8",
	"./icon-track-blue.svg": "dffe",
	"./icon-track-dark.svg": "8cc0",
	"./icon-track-gray.svg": "58c7",
	"./icon-track-graylight.svg": "6f3f",
	"./icon-track-light-blue-horizontal.svg": "8971",
	"./icon-track-light-blue.svg": "f71c",
	"./icon-track-light-horizontal.svg": "2872",
	"./icon-track-light.svg": "80c5",
	"./icon-track-white.svg": "7de1",
	"./icon-tracker-gray-light.svg": "cce4",
	"./icon-tracker.png": "6b9d",
	"./icon-trash-can.svg": "21ca",
	"./icon-trends.png": "ed87",
	"./icon-trends2.svg": "b6b5",
	"./icon-triangle.svg": "60bf",
	"./icon-twitter.svg": "add1",
	"./icon-user-blue.svg": "ff27",
	"./icon-user-gray.svg": "e67f",
	"./icon-user-white.svg": "3eb4",
	"./icon-user.svg": "1871",
	"./icon-users-gray.svg": "e572",
	"./icon-valuation.svg": "7b2d",
	"./icon-vc.svg": "8e24",
	"./icon-video-play.svg": "369e",
	"./icon-view-light.svg": "a666",
	"./icon-view.svg": "f7fd",
	"./icon-walkthrough.svg": "9396",
	"./icon-watched.svg": "f137",
	"./icon-wrench.svg": "45e7",
	"./icon-x-gray.svg": "1b52",
	"./icon-x.svg": "6755",
	"./icon-y.svg": "a05d",
	"./icon-youtube.svg": "34e2",
	"./icons-filter-blue.svg": "9456",
	"./icons-filter-light.svg": "db21",
	"./icons-filter.svg": "2ce0",
	"./icons-profile.svg": "621b",
	"./icons-remove.svg": "fc86",
	"./icons-right-arrow.svg": "dbdc",
	"./linkedin.svg": "4065",
	"./logo-RTX.png": "c980",
	"./logo-bloomberg.png": "b7f1",
	"./logo-entrepreneur.png": "689b",
	"./logo-inc.png": "edb3",
	"./logo-mc.svg": "5c28",
	"./logo-on-white.png": "356b",
	"./logo-pdf-link.svg": "9142",
	"./logo-rtx.svg": "241e",
	"./logo-travellers.png": "d5b5",
	"./logo-upstart.png": "7d35",
	"./logo-usnews.png": "433e",
	"./logo.png": "a961",
	"./logo.svg": "4c3b",
	"./lopez.png": "f4ae",
	"./manager.png": "4541",
	"./minimize.svg": "566f",
	"./modal-previews/activity-feed-preview.png": "e581",
	"./modal-previews/add-startup-preview.png": "dc21",
	"./modal-previews/analyst-hours.png": "e7e1",
	"./modal-previews/fields-history-preview.png": "bdfe",
	"./modal-previews/img1.png": "93bd",
	"./notify-icon-error.svg": "bd77",
	"./notify-icon-warn.svg": "aced",
	"./popover-arrow.png": "b3d8",
	"./rectangle-gray.svg": "371f",
	"./rectangle.svg": "f75d",
	"./save.svg": "db5e",
	"./search-button.svg": "269a",
	"./search-dark.svg": "0c13",
	"./search.svg": "716d",
	"./sp-logo.svg": "8c07",
	"./sp-popup-bg.png": "9b62",
	"./star-full.svg": "e52c",
	"./star-yellow.svg": "71eb",
	"./star.svg": "1594",
	"./start-ups-black.svg": "4e9c",
	"./start-ups-gray.svg": "0bb9",
	"./start-ups-green.svg": "a2ae",
	"./start-ups.svg": "c2fe",
	"./startup-info-employes-gray.svg": "e654",
	"./startup-info-employes.svg": "37ec",
	"./synapse-homepage.webp": "7ed9",
	"./synapse/admin/synapse-homepage1.png": "decd",
	"./synapse/admin/synapse-homepage2.png": "9261",
	"./synapse/admin/synapse-homepage3.png": "2c1e",
	"./synapse/synapse-homepage1.png": "b8df",
	"./synapse/synapse-homepage2.png": "044a",
	"./synapse/synapse-homepage3.png": "aedb",
	"./time-badge-bronze.svg": "9967",
	"./time-badge-gold.svg": "8b85",
	"./time-badge-platinum.svg": "e4465",
	"./time-badge-silver.svg": "d667",
	"./time-badge-start.svg": "f13e",
	"./tracker-report-templates-previews/comprehensive-report.jpeg": "7a68",
	"./tracker-report-templates-previews/deep-dive-report-old.png": "c61e",
	"./tracker-report-templates-previews/deep-dive-report.png": "f3a4",
	"./tracker-report-templates-previews/high-level-overview.jpeg": "278b",
	"./tracker-report-templates-previews/insights-report-background.png": "2c6b",
	"./tracker-report-templates-previews/summary-report.png": "e52b",
	"./tracker-report-templates-previews/summary-report1.png": "b903",
	"./user1.png": "d168",
	"./user2.png": "614e",
	"./viva.png": "6f82",
	"./warning-red.svg": "e911"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4339";